<app-modal *ngIf="vo$ | async; let vo" class="app-consumer-config-modal">

	<div class="app-consumer-config-modal__body" modal-body>
		<ng-container *ngIf="vo.action === ConsumerConfigAction.Update && vo.selectedConsumer">
			<dc-alert
				type="warning"
				message="consumer"
				i18n-message="@@subscription.consumer.update.description"></dc-alert>

			<app-card-outline class="project-details-card">
				<div card-outline-title>
					<span
						i18n="@@subscription.consumer.config.project.title">
						Project</span>
				</div>
				<div card-outline-content class="project-details-card__content">
					<!-- Project's Label -->
					<span
						class="data-label"
						i18n="@@subscription.consumer.config.project.label">
						project-label</span>

					<div class="value">
						{{vo.selectedConsumer.projectLabel}}
						<div class="version-badge" *ngFor="let version of vo.selectedConsumer.targetProjectVersions">
							{{version}}
						</div>
					</div>
				</div>
			</app-card-outline>

			<app-profiles
				[profiles]="vo.profiles"
				[columnModels]="vo.columnModels"
				[mode]="'PROJECT_STANDALONE'"
				[selectedId]="vo.selectedConsumer.profileUuid"
				(reloadProfiles)="refreshProfiles()"></app-profiles>
		</ng-container>

		<ng-container *ngIf="vo.action === ConsumerConfigAction.Create">
			<dc-alert
				type="info"
				message="consumer"
				i18n-message="@@subscription.consumer.create.description"></dc-alert>

			<mat-accordion [multi]="false">
				<!-- PROFILE -->
				<mat-expansion-panel
					[expanded]="vo.currentStep === ConsumerConfigStep.ProfileSelection"
					(opened)="setStep(ConsumerConfigStep.ProfileSelection)">
					<mat-expansion-panel-header
						[ngClass]="vo.errors.get(SubscriptionErrorKey.NoSelectProfile) ?  'invalid-step': 'valid-step'">
						<mat-panel-title
							i18n="@@subscription.consumer.config.profileSelectionStep.title">
							profile-step-title</mat-panel-title>
						<mat-panel-description
							i18n="@@subscription.consumer.config.profileSelectionStep.description">
							profile-step-description
						</mat-panel-description>
					</mat-expansion-panel-header>

					<app-profiles
						[profiles]="vo.profiles"
						[columnModels]="vo.columnModels"
						[mode]="'PROJECT_STANDALONE'"
						[selectedId]="vo.selectedConsumer.profileUuid"
						(reloadProfiles)="refreshProfiles()"></app-profiles>

					<mat-action-row>
						<button
							mat-flat-button
							color="primary"
							(click)="nextStep()">
							<span
								i18n="@@general.stepper.next">
								next</span>
						</button>
					</mat-action-row>
				</mat-expansion-panel>

				<!-- PROJECTS -->
				<mat-expansion-panel
					[expanded]="vo.currentStep === ConsumerConfigStep.ProjectsSelection"
					(opened)="setStep(ConsumerConfigStep.ProjectsSelection)">
					<mat-expansion-panel-header
						[ngClass]="vo.errors.get(SubscriptionErrorKey.NoSelectProject) ?  'invalid-step': 'valid-step'">
						<mat-panel-title
							i18n="@@subscription.consumer.config.projectsSelectionStep.title">
							project-step-title</mat-panel-title>
						<mat-panel-description
							i18n="@@subscription.consumer.config.projectsSelectionStep.description">
							project-step-description
						</mat-panel-description>
					</mat-expansion-panel-header>

					<app-panel
						headerHeight="3rem"
						isAlwaysOpen="true"
						hasSearchableGrid="true"
						hasRefresh="true"
						[itemsCount]="vo.projectList.elements.size"
						(refresh)="refreshProjects()">
						<div panel-title
								 class="app-panel__title">
							<mat-icon [svgIcon]="ComponentIcons.Project"></mat-icon>
							<span
								i18n="@@subscription.project.list.title">
								projects</span>
						</div>
						<ng-container
							[ngTemplateOutlet]="projectList"
							[ngTemplateOutletContext]="{ projectList : vo.projectList, action : vo.action }"></ng-container>
					</app-panel>

					<mat-action-row>
						<button
							mat-flat-button
							color="primary"
							(click)="previousStep()">
							<span
								i18n="@@general.stepper.back">
								back</span>
						</button>
					</mat-action-row>
				</mat-expansion-panel>
			</mat-accordion>
		</ng-container>
	</div>

	<div modal-footer class="app-consumer-config-modal__footer">
		<div *ngIf="vo.errors.valueSeq().first() as error"
			class="error-alert error">
			<mat-icon
				[ngClass]="{ 'warning': error.type === 'warning' }"
				color="warn"
				[svgIcon]="error.type === 'critic'? DcIcons.Error: DcIcons.Warning">
			</mat-icon>
			<span>{{error.message}}</span>
		</div>

		<button
			*ngIf="vo.action === ConsumerConfigAction.Create"
			id="{{ cmpId }}-save-btn"
			[disabled]="vo.errors.size !== 0"
			[color]="'primary'"
			(click)="createAction()"
			mat-raised-button>
			<span
				i18n="@@general.action.new">
				save</span>
		</button>

		<button
			*ngIf="vo.action === ConsumerConfigAction.Update"
			id="{{ cmpId }}-save-btn"
			[disabled]="vo.errors.size !== 0"
			[color]="'primary'"
			(click)="updateAction()"
			mat-raised-button>
			<span
				i18n="@@general.action.validate">
				validate</span>
		</button>
	</div>
</app-modal>

<ng-template #projectList let-projectList="projectList" let-action="action">
		<dx-data-grid
			keyExpr="id"
			[elementAttr]="{id: 'project-list',class: 'project-list'}"
			[dataSource]="projectList.elements | toArray"
			[hoverStateEnabled]="true"
			[showColumnHeaders]="true"
			[allowColumnResizing]="true"
			[columnAutoWidth]="false"
			[showRowLines]="false"
			[showColumnLines]="false"
			[rowAlternationEnabled]="false"
			[showBorders]="false"
			[width]="'100%'"
			(onSelectionChanged)="selectProjects($event)"
			(onRowClick)="onRowClick($event)"
			(onContentReady)="onGridReady()">

			<dxo-selection
				mode="multiple"
				showCheckBoxesMode="always"></dxo-selection>

			<dxo-load-panel
				shadingColor="rgba(0,0,0,0)"
				[indicatorSrc]="DcLoaders.LoaderInfinite"
				[height]="100"
				[width]="100"
				[enabled]="true"
				[showIndicator]="true"
				[showPane]="true"
				[shading]="true"></dxo-load-panel>

			<!-- Fixable in position columns	-->
			<dxo-column-fixing [enabled]="true"></dxo-column-fixing>

			<ng-container
				*ngFor="let col of projectList.availableColumns | toArray">
				<dxi-column
					*ngIf="col.field === 'label'"
					[dataField]="col.field"
					[caption]="col.alias"
					[groupIndex]="col.groupIdx"
					[visibleIndex]="col.visibleIndex"
					[fixed]="false"
					[allowResizing]="true"
					[allowHiding]="true"
					[allowGrouping]="true"
					[allowSearch]="col.isSearchable"
					[allowFiltering]="col.isFilterable"
					[allowSorting]="true"
					[alignment]="'left'"
					[allowEditing]="false"
					[visible]="col.visible"
					[width]="'15%'"></dxi-column>

				<dxi-column
					*ngIf="col.field === 'version'"
					[dataField]="col.field"
					[caption]="col.alias"
					[groupIndex]="col.groupIdx"
					[visibleIndex]="col.visibleIndex"
					[fixed]="false"
					[allowResizing]="true"
					[allowHiding]="true"
					[allowGrouping]="true"
					[allowSearch]="col.isSearchable"
					[allowFiltering]="col.isFilterable"
					[allowSorting]="true"
					[alignment]="'left'"
					[allowEditing]="false"
					[visible]="false"
					[width]="'10%'"
					cellTemplate="versionTemplate"></dxi-column>

				<dxi-column
					*ngIf="col.field === 'description'"
					[dataField]="col.field"
					[caption]="col.alias"
					[groupIndex]="col.groupIdx"
					[visibleIndex]="col.visibleIndex"
					[fixed]="false"
					[allowResizing]="true"
					[allowHiding]="true"
					[allowGrouping]="true"
					[allowSearch]="col.isSearchable"
					[allowFiltering]="col.isFilterable"
					[allowSorting]="true"
					[alignment]="'left'"
					[allowEditing]="false"
					[visible]="col.visible"
					[width]="'50%'"></dxi-column>

				<dxi-column
					*ngIf="col.field === 'tags'"
					[dataField]="col.field"
					[caption]="col.alias"
					[groupIndex]="col.groupIdx"
					[visibleIndex]="col.visibleIndex"
					[fixed]="false"
					[allowResizing]="true"
					[allowHiding]="true"
					[allowGrouping]="true"
					[allowSearch]="col.isSearchable"
					[allowFiltering]="col.isFilterable"
					[allowSorting]="true"
					[alignment]="'left'"
					[visible]="col.visible"
					[width]="'35%'"
					cellTemplate="tagsTemplate"></dxi-column>
			</ng-container>

			<div *dxTemplate="let cell of 'tagsTemplate'">
				<app-tag-configurator
					*ngIf="cell.data['tags'].length !== 0"
					displayMode="tags"
					configMode="View"
					[configuredTags]="cell.data['tags']"></app-tag-configurator>
			</div>

			<div *dxTemplate="let cell of 'versionTemplate'">
				<div class="version-badge">
					<span>{{cell.data['version']}}</span>
				</div>
			</div>
			<!-- Sorting	-->
			<dxo-sorting mode="multiple"></dxo-sorting>

			<!-- Pagination -->
			<dxo-paging [pageSize]="1000"></dxo-paging>

			<dxo-pager [visible]="false"></dxo-pager>

			<!-- Filterable columns	-->
			<dxo-header-filter [visible]="true"></dxo-header-filter>

			<dxo-filter-row [visible]="true"></dxo-filter-row>

		</dx-data-grid>
</ng-template>
